import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  height?: number;
  href?: string;
  className?: string;
}

export default function Logo({ height = 36, href, className = '' }: LogoProps) {
  const width = Math.round(height * (1398 / 868)); // aspect ratio logo-no-background
  const img = (
    <Image
      src="/logo.png"
      alt="MR CODE"
      width={width}
      height={height}
      className={`object-contain ${className}`}
      priority
    />
  );
  if (href) {
    return (
      <Link href={href} className="flex items-center shrink-0">
        {img}
      </Link>
    );
  }
  return <div className="flex items-center shrink-0">{img}</div>;
}
